import { defineComponent as Ze, watchEffect as re, ref as p, computed as N, watch as K, nextTick as q, provide as et, toRef as _, h as s, withDirectives as tt, vShow as nt, TransitionGroup as at, cloneVNode as ot } from "vue";
import { tabsInjectionKey as it } from "./ghl-ui.es1096.js";
import Z from "./ghl-ui.es176.js";
import st from "./ghl-ui.es1097.js";
import { warnOnce as J } from "./ghl-ui.es859.js";
import lt from "./ghl-ui.es860.js";
import he from "./ghl-ui.es861.js";
import de from "./ghl-ui.es694.js";
import { flatten as X } from "./ghl-ui.es925.js";
import rt from "./ghl-ui.es692.js";
import Q from "./ghl-ui.es1098.js";
import dt from "./ghl-ui.es687.js";
import { createKey as x } from "./ghl-ui.es704.js";
import { getMargin as k } from "./ghl-ui.es739.js";
import { useThemeClass as ct } from "./ghl-ui.es862.js";
import { resolveWrappedSlot as ce } from "./ghl-ui.es865.js";
import fe from "./ghl-ui.es736.js";
import ft from "./ghl-ui.es658.js";
import ut from "./ghl-ui.es1099.js";
import { call as M } from "./ghl-ui.es898.js";
const pt = Object.assign(Object.assign({}, he.props), {
  value: [String, Number],
  defaultValue: [String, Number],
  trigger: {
    type: String,
    default: "click"
  },
  type: {
    type: String,
    default: "bar"
  },
  closable: Boolean,
  justifyContent: String,
  size: {
    type: String,
    default: "medium"
  },
  placement: {
    type: String,
    default: "top"
  },
  tabStyle: [String, Object],
  barWidth: Number,
  paneClass: String,
  paneStyle: [String, Object],
  paneWrapperClass: String,
  paneWrapperStyle: [String, Object],
  addable: [Boolean, Object],
  tabsPadding: {
    type: Number,
    default: 0
  },
  animated: Boolean,
  onBeforeLeave: Function,
  onAdd: Function,
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array],
  onClose: [Function, Array],
  // deprecated
  labelSize: String,
  activeName: [String, Number],
  onActiveNameChange: [Function, Array]
}), Bt = Ze({
  name: "Tabs",
  props: pt,
  setup(n, { slots: l }) {
    var C, T, b, w;
    process.env.NODE_ENV !== "production" && re(() => {
      n.labelSize !== void 0 && J("tabs", "`label-size` is deprecated, please use `size` instead."), n.activeName !== void 0 && J("tabs", "`active-name` is deprecated, please use `value` instead."), n.onActiveNameChange !== void 0 && J("tabs", "`on-active-name-change` is deprecated, please use `on-update:value` instead.");
    });
    const { mergedClsPrefixRef: d, inlineThemeDisabled: g } = lt(n), R = he("Tabs", "-tabs", st, ut, n, d), y = p(null), h = p(null), A = p(null), W = p(null), c = p(null), f = p(!0), P = p(!0), S = de(n, ["labelSize", "size"]), E = de(n, ["activeName", "value"]), m = p((T = (C = E.value) !== null && C !== void 0 ? C : n.defaultValue) !== null && T !== void 0 ? T : l.default ? (w = (b = X(l.default())[0]) === null || b === void 0 ? void 0 : b.props) === null || w === void 0 ? void 0 : w.name : null), $ = rt(E, m), L = { id: 0 }, i = N(() => {
      if (!(!n.justifyContent || n.type === "card"))
        return {
          display: "flex",
          justifyContent: n.justifyContent
        };
    });
    K($, () => {
      L.id = 0, O(), te();
    });
    function r() {
      var e;
      const { value: t } = $;
      return t === null ? null : (e = y.value) === null || e === void 0 ? void 0 : e.querySelector(`[data-name="${t}"]`);
    }
    function j(e) {
      if (n.type === "card")
        return;
      const { value: t } = h;
      if (t && e) {
        const a = `${d.value}-tabs-bar--disabled`, { barWidth: o, placement: u } = n;
        if (e.dataset.disabled === "true" ? t.classList.add(a) : t.classList.remove(a), ["top", "bottom"].includes(u)) {
          if (ee(["top", "maxHeight", "height"]), typeof o == "number" && e.offsetWidth >= o) {
            const v = Math.floor((e.offsetWidth - o) / 2) + e.offsetLeft;
            t.style.left = `${v}px`, t.style.maxWidth = `${o}px`;
          } else
            t.style.left = `${e.offsetLeft}px`, t.style.maxWidth = `${e.offsetWidth}px`;
          t.style.width = "8192px", t.offsetWidth;
        } else {
          if (ee(["left", "maxWidth", "width"]), typeof o == "number" && e.offsetHeight >= o) {
            const v = Math.floor((e.offsetHeight - o) / 2) + e.offsetTop;
            t.style.top = `${v}px`, t.style.maxHeight = `${o}px`;
          } else
            t.style.top = `${e.offsetTop}px`, t.style.maxHeight = `${e.offsetHeight}px`;
          t.style.height = "8192px", t.offsetHeight;
        }
      }
    }
    function ee(e) {
      const { value: t } = h;
      if (t)
        for (const a of e)
          t.style[a] = "";
    }
    function O() {
      if (n.type === "card")
        return;
      const e = r();
      e && j(e);
    }
    function te(e) {
      var t;
      const a = (t = c.value) === null || t === void 0 ? void 0 : t.$el;
      if (!a)
        return;
      const o = r();
      if (!o)
        return;
      const { scrollLeft: u, offsetWidth: v } = a, { offsetLeft: H, offsetWidth: I } = o;
      u > H ? a.scrollTo({
        top: 0,
        left: H,
        behavior: "smooth"
      }) : H + I > u + v && a.scrollTo({
        top: 0,
        left: H + I - v,
        behavior: "smooth"
      });
    }
    const F = p(null);
    let U = 0, z = null;
    function me(e) {
      const t = F.value;
      if (t) {
        U = e.getBoundingClientRect().height;
        const a = `${U}px`, o = () => {
          t.style.height = a, t.style.maxHeight = a;
        };
        z ? (o(), z(), z = null) : z = o;
      }
    }
    function ve(e) {
      const t = F.value;
      if (t) {
        const a = e.getBoundingClientRect().height, o = () => {
          document.body.offsetHeight, t.style.maxHeight = `${a}px`, t.style.height = `${Math.max(U, a)}px`;
        };
        z ? (z(), z = null, o()) : z = o;
      }
    }
    function ge() {
      const e = F.value;
      if (e) {
        e.style.maxHeight = "", e.style.height = "";
        const { paneWrapperStyle: t } = n;
        if (typeof t == "string")
          e.style.cssText = t;
        else if (t) {
          const { maxHeight: a, height: o } = t;
          a !== void 0 && (e.style.maxHeight = a), o !== void 0 && (e.style.height = o);
        }
      }
    }
    const ne = { value: [] }, ae = p("next");
    function ye(e) {
      const t = $.value;
      let a = "next";
      for (const o of ne.value) {
        if (o === t)
          break;
        if (o === e) {
          a = "prev";
          break;
        }
      }
      ae.value = a, Se(e);
    }
    function Se(e) {
      const { onActiveNameChange: t, onUpdateValue: a, "onUpdate:value": o } = n;
      t && M(t, e), a && M(a, e), o && M(o, e), m.value = e;
    }
    function xe(e) {
      const { onClose: t } = n;
      t && M(t, e);
    }
    function oe() {
      const { value: e } = h;
      if (!e)
        return;
      const t = "transition-disabled";
      e.classList.add(t), O(), e.classList.remove(t);
    }
    let ie = 0;
    function Ce(e) {
      var t;
      if (e.contentRect.width === 0 && e.contentRect.height === 0 || ie === e.contentRect.width)
        return;
      ie = e.contentRect.width;
      const { type: a } = n;
      (a === "line" || a === "bar") && oe(), a !== "segment" && G((t = c.value) === null || t === void 0 ? void 0 : t.$el);
    }
    const Re = Q(Ce, 64);
    K([() => n.justifyContent, () => n.size], () => {
      q(() => {
        const { type: e } = n;
        (e === "line" || e === "bar") && oe();
      });
    });
    const D = p(!1);
    function $e(e) {
      var t;
      const { target: a, contentRect: { width: o } } = e, u = a.parentElement.offsetWidth;
      if (!D.value)
        u < o && (D.value = !0);
      else {
        const { value: v } = W;
        if (!v)
          return;
        u - o > v.$el.offsetWidth && (D.value = !1);
      }
      G((t = c.value) === null || t === void 0 ? void 0 : t.$el);
    }
    const Te = Q($e, 64);
    function We() {
      const { onAdd: e } = n;
      e && e(), q(() => {
        const t = r(), { value: a } = c;
        !t || !a || a.scrollTo({
          left: t.offsetLeft,
          top: 0,
          behavior: "smooth"
        });
      });
    }
    function G(e) {
      if (!e)
        return;
      const { placement: t } = n;
      if (t === "top" || t === "bottom") {
        const { scrollLeft: a, scrollWidth: o, offsetWidth: u } = e;
        f.value = a <= 0, P.value = a + u >= o;
      } else {
        const { scrollTop: a, scrollHeight: o, offsetHeight: u } = e;
        f.value = a <= 0, P.value = a + u >= o;
      }
    }
    const Pe = Q((e) => {
      G(e.target);
    }, 64);
    et(it, {
      triggerRef: _(n, "trigger"),
      tabStyleRef: _(n, "tabStyle"),
      paneClassRef: _(n, "paneClass"),
      paneStyleRef: _(n, "paneStyle"),
      mergedClsPrefixRef: d,
      typeRef: _(n, "type"),
      closableRef: _(n, "closable"),
      valueRef: $,
      tabChangeIdRef: L,
      onBeforeLeaveRef: _(n, "onBeforeLeave"),
      activateTab: ye,
      handleClose: xe,
      handleAdd: We
    }), dt(() => {
      O(), te();
    }), re(() => {
      const { value: e } = A;
      if (!e)
        return;
      const { value: t } = d, a = `${t}-tabs-nav-scroll-wrapper--shadow-start`, o = `${t}-tabs-nav-scroll-wrapper--shadow-end`;
      f.value ? e.classList.remove(a) : e.classList.add(a), P.value ? e.classList.remove(o) : e.classList.add(o);
    });
    const se = p(null);
    K($, () => {
      if (n.type === "segment") {
        const e = se.value;
        e && q(() => {
          e.classList.add("transition-disabled"), e.offsetWidth, e.classList.remove("transition-disabled");
        });
      }
    });
    const Le = {
      syncBarPosition: () => {
        O();
      }
    }, le = N(() => {
      const { value: e } = S, { type: t } = n, a = {
        card: "Card",
        bar: "Bar",
        line: "Line",
        segment: "Segment"
      }[t], o = `${e}${a}`, { self: { barColor: u, closeIconColor: v, closeIconColorHover: H, closeIconColorPressed: I, tabColor: ze, tabBorderColor: we, paneTextColor: _e, tabFontWeight: Ae, tabBorderRadius: Ee, tabFontWeightActive: Be, colorSegment: He, fontWeightStrong: je, tabColorSegment: Oe, closeSize: Fe, closeIconSize: De, closeColorHover: Ie, closeColorPressed: Ve, closeBorderRadius: ke, [x("panePadding", e)]: V, [x("tabPadding", o)]: Me, [x("tabPaddingVertical", o)]: Ue, [x("tabGap", o)]: Ge, [x("tabGap", `${o}Vertical`)]: Ne, [x("tabTextColor", t)]: Ke, [x("tabTextColorActive", t)]: qe, [x("tabTextColorHover", t)]: Je, [x("tabTextColorDisabled", t)]: Xe, [x("tabFontSize", e)]: Qe }, common: { cubicBezierEaseInOut: Ye } } = R.value;
      return {
        "--n-bezier": Ye,
        "--n-color-segment": He,
        "--n-bar-color": u,
        "--n-tab-font-size": Qe,
        "--n-tab-text-color": Ke,
        "--n-tab-text-color-active": qe,
        "--n-tab-text-color-disabled": Xe,
        "--n-tab-text-color-hover": Je,
        "--n-pane-text-color": _e,
        "--n-tab-border-color": we,
        "--n-tab-border-radius": Ee,
        "--n-close-size": Fe,
        "--n-close-icon-size": De,
        "--n-close-color-hover": Ie,
        "--n-close-color-pressed": Ve,
        "--n-close-border-radius": ke,
        "--n-close-icon-color": v,
        "--n-close-icon-color-hover": H,
        "--n-close-icon-color-pressed": I,
        "--n-tab-color": ze,
        "--n-tab-font-weight": Ae,
        "--n-tab-font-weight-active": Be,
        "--n-tab-padding": Me,
        "--n-tab-padding-vertical": Ue,
        "--n-tab-gap": Ge,
        "--n-tab-gap-vertical": Ne,
        "--n-pane-padding-left": k(V, "left"),
        "--n-pane-padding-right": k(V, "right"),
        "--n-pane-padding-top": k(V, "top"),
        "--n-pane-padding-bottom": k(V, "bottom"),
        "--n-font-weight-strong": je,
        "--n-tab-color-segment": Oe
      };
    }), B = g ? ct("tabs", N(() => `${S.value[0]}${n.type[0]}`), le, n) : void 0;
    return Object.assign({
      mergedClsPrefix: d,
      mergedValue: $,
      renderedNames: /* @__PURE__ */ new Set(),
      tabsRailElRef: se,
      tabsPaneWrapperRef: F,
      tabsElRef: y,
      barElRef: h,
      addTabInstRef: W,
      xScrollInstRef: c,
      scrollWrapperElRef: A,
      addTabFixed: D,
      tabWrapperStyle: i,
      handleNavResize: Re,
      mergedSize: S,
      handleScroll: Pe,
      handleTabsResize: Te,
      cssVars: g ? void 0 : le,
      themeClass: B == null ? void 0 : B.themeClass,
      animationDirection: ae,
      renderNameListRef: ne,
      onAnimationBeforeLeave: me,
      onAnimationEnter: ve,
      onAnimationAfterEnter: ge,
      onRender: B == null ? void 0 : B.onRender
    }, Le);
  },
  render() {
    const { mergedClsPrefix: n, type: l, placement: C, addTabFixed: T, addable: b, mergedSize: w, renderNameListRef: d, onRender: g, paneWrapperClass: R, paneWrapperStyle: y, $slots: { default: h, prefix: A, suffix: W } } = this;
    g == null || g();
    const c = h ? X(h()).filter((i) => i.type.__TAB_PANE__ === !0) : [], f = h ? X(h()).filter((i) => i.type.__TAB__ === !0) : [], P = !f.length, S = l === "card", E = l === "segment", m = !S && !E && this.justifyContent;
    d.value = [];
    const $ = () => {
      const i = s(
        "div",
        { style: this.tabWrapperStyle, class: [`${n}-tabs-wrapper`] },
        m ? null : s("div", { class: `${n}-tabs-scroll-padding`, style: { width: `${this.tabsPadding}px` } }),
        P ? c.map((r, j) => (d.value.push(r.props.name), Y(s(Z, Object.assign({}, r.props, { internalCreatedByPane: !0, internalLeftPadded: j !== 0 && (!m || m === "center" || m === "start" || m === "end") }), r.children ? {
          default: r.children.tab
        } : void 0)))) : f.map((r, j) => (d.value.push(r.props.name), Y(j !== 0 && !m ? be(r) : r))),
        !T && b && S ? pe(b, (P ? c.length : f.length) !== 0) : null,
        m ? null : s("div", { class: `${n}-tabs-scroll-padding`, style: { width: `${this.tabsPadding}px` } })
      );
      return s(
        "div",
        { ref: "tabsElRef", class: `${n}-tabs-nav-scroll-content` },
        S && b ? s(fe, { onResize: this.handleTabsResize }, {
          default: () => i
        }) : i,
        S ? s("div", { class: `${n}-tabs-pad` }) : null,
        S ? null : s("div", { ref: "barElRef", class: `${n}-tabs-bar` })
      );
    }, L = E ? "top" : C;
    return s(
      "div",
      { class: [
        `${n}-tabs`,
        this.themeClass,
        `${n}-tabs--${l}-type`,
        `${n}-tabs--${w}-size`,
        m && `${n}-tabs--flex`,
        `${n}-tabs--${L}`
      ], style: this.cssVars },
      s(
        "div",
        { class: [
          // the class should be applied here since it's possible
          // to make tabs nested in tabs, style may influence each
          // other. adding a class will make it easy to write the
          // style.
          `${n}-tabs-nav--${l}-type`,
          `${n}-tabs-nav--${L}`,
          `${n}-tabs-nav`
        ] },
        ce(A, (i) => i && s("div", { class: `${n}-tabs-nav__prefix` }, i)),
        E ? s("div", { class: `${n}-tabs-rail`, ref: "tabsRailElRef" }, P ? c.map((i, r) => (d.value.push(i.props.name), s(Z, Object.assign({}, i.props, { internalCreatedByPane: !0, internalLeftPadded: r !== 0 }), i.children ? {
          default: i.children.tab
        } : void 0))) : f.map((i, r) => (d.value.push(i.props.name), r === 0 ? i : be(i)))) : s(fe, { onResize: this.handleNavResize }, {
          default: () => s("div", { class: `${n}-tabs-nav-scroll-wrapper`, ref: "scrollWrapperElRef" }, ["top", "bottom"].includes(L) ? s(ft, { ref: "xScrollInstRef", onScroll: this.handleScroll }, {
            default: $
          }) : s("div", { class: `${n}-tabs-nav-y-scroll`, onScroll: this.handleScroll }, $()))
        }),
        T && b && S ? pe(b, !0) : null,
        ce(W, (i) => i && s("div", { class: `${n}-tabs-nav__suffix` }, i))
      ),
      P && (this.animated && (L === "top" || L === "bottom") ? s("div", { ref: "tabsPaneWrapperRef", style: y, class: [`${n}-tabs-pane-wrapper`, R] }, ue(c, this.mergedValue, this.renderedNames, this.onAnimationBeforeLeave, this.onAnimationEnter, this.onAnimationAfterEnter, this.animationDirection)) : ue(c, this.mergedValue, this.renderedNames))
    );
  }
});
function ue(n, l, C, T, b, w, d) {
  const g = [];
  return n.forEach((R) => {
    const { name: y, displayDirective: h, "display-directive": A } = R.props, W = (f) => h === f || A === f, c = l === y;
    if (R.key !== void 0 && (R.key = y), c || W("show") || W("show:lazy") && C.has(y)) {
      C.has(y) || C.add(y);
      const f = !W("if");
      g.push(f ? tt(R, [[nt, c]]) : R);
    }
  }), d ? s(at, { name: `${d}-transition`, onBeforeLeave: T, onEnter: b, onAfterEnter: w }, { default: () => g }) : g;
}
function pe(n, l) {
  return s(Z, { ref: "addTabInstRef", key: "__addable", name: "__addable", internalCreatedByPane: !0, internalAddable: !0, internalLeftPadded: l, disabled: typeof n == "object" && n.disabled });
}
function be(n) {
  const l = ot(n);
  return l.props ? l.props.internalLeftPadded = !0 : l.props = {
    internalLeftPadded: !0
  }, l;
}
function Y(n) {
  return Array.isArray(n.dynamicProps) ? n.dynamicProps.includes("internalLeftPadded") || n.dynamicProps.push("internalLeftPadded") : n.dynamicProps = ["internalLeftPadded"], n;
}
export {
  Bt as default,
  pt as tabsProps
};
